export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/stlWorker.worker.9af4be4d.worker.js");
}
